import classNames from 'classnames';

import { Button } from '@revelio/ui';

import styles from './tabs-list.module.css';

export interface TabsListProps {
  tabs: string[];
  setTab: (tab: string) => void;
  tab: string;
}

export function TabsList(props: TabsListProps) {
  return (
    <>
      {props.tabs.map((item, i) => {
        const isActive = props.tab === item;
        return (
          <Button
            key={i}
            variant="ghost"
            className={classNames(styles.tab, isActive && styles.active)}
            onClick={() => props.setTab(item)}
          >
            {item}
          </Button>
        );
      })}
    </>
  );
}
